/**
 * Shared relative-time formatter for the CSR command-centre mock pages
 * (feed cards, board comms chips, calendar rail, unread-email digest,
 * JobCommsSection's email rows all need the same "3h ago" / "2d ago"
 * shape). Colocated here as the single source rather than duplicated
 * per component.
 */
import { formatTimeOrDash } from "@shared-core/domain/formatters";
import { currentTime } from "@shared-core/domain/current-time";

export function formatRelativeTime(iso: string): string {
  const minutes = Math.floor(
    (currentTime().getTime() - new Date(iso).getTime()) / 60000,
  );
  if (minutes < 1) return "just now";
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

export function formatClockTime(iso: string): string {
  return formatTimeOrDash(iso);
}
